import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shorty',
    standalone: false
})
export class ShortyPipe implements PipeTransform {

  transform(value: string | null | undefined, length: number = 16): string {
    if (!value) {
      return '';
    }
    return value.length > length ? value.slice(0, length) + "..." : value;
  }

}
